import { useMemo } from "react";
import { CollectionShareButtonContainer } from "../CollectionShareDialog";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Header(props) {
  const applications = useMemo(() => props.projects.map(p => ({
    chainId: p.chainId,
    roundId: p.roundId,
    id: p.grantApplicationId
  })), [props.projects]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex mt-5 border-b-2 pb-2",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "grow text-3xl",
        children: "Cart"
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(CollectionShareButtonContainer, {
          showOnlyInAlloVersion: "allo-v2",
          applications: applications
        })
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "mt-6 leading-6",
      children: "Cross-Round, Cross-Network Giving \uD83C\uDF10 \uD83D\uDED2"
    }), /*#__PURE__*/_jsx("p", {
      className: "mt-2 mb-5 leading-6",
      children: "Donate seamlessly across multiple rounds and networks. Add projects to your cart and make a difference."
    })]
  });
}